import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

export const getProviderDocuments = ( provider_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/documents';

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const saveProviderDocument = ( provider_id, data, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/documents';

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const deleteProviderDocument = ( provider_id, enc_doc_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/establishment/' + provider_id + '/documents/' + enc_doc_id;

    getDataWithPromise ( url, 'DELETE', null )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}